<div class="container-fluid py-4">
  <div class="row justify-content-center">
    <div class="col-4 col-md-2" *ngFor="let card of resumenCards; index as i">
      <!-- [class]="i < 2 ? 'col-md-6' : 'col-md-4'" -->
      <div
        class="card card-stats"
        [ngClass]="{ 'card-stats__selected': i === 0 }"
        [routerLink]="card.route"
        [style.cursor]="card.route ? 'pointer' : 'default'"
      >
        <div class="card-body">
          <div class="row">
            <div class="col-12 col-md-7 col-lg-6">
              <div
                class="icon-big text-center text-dark rounded shadow"
                [ngClass]="card.bgClass"
              >
                <i [class]="card.icon"></i>
              </div>
            </div>
            <div class="col-7 d-flex flex-column justify-content-center">
              <p class="card-category mb-0">{{ card.label }}</p>
              <h4
                class="card-title mb-0"
                [ngClass]="{ 'text-dark': i === 0, 'text-white': i !== 0 }"
              >
                {{ card.value }}
              </h4>
            </div>
          </div>
        </div>
        <div class="card-footer">
          <div class="stats">
            <small [class]="i == 0 ? 'desc__selected' : 'desc'">{{
              card.desc
            }}</small>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col-12 d-flex align-items-center justify-content-between">
      <div class="flex-grow-1 text-center">
        <a
          class="btn btn-dark btn-sm btn-new"
          [routerLink]="['/marketing/seo/registry']"
        >
          Registry
        </a>
        <a
          class="btn btn-dark btn-sm btn-new"
          [routerLink]="['/marketing/seo/qaRun']"
        >
          QA Run
        </a>
        <a
          class="btn btn-dark btn-sm btn-reg"
          [routerLink]="['/marketing/seo/internalLinks']"
        >
          Internal Links
        </a>

        <a
          class="btn btn-dark btn-sm btn-new"
          [routerLink]="['/marketing/seo/offPageDashboard']"
        >
          On-P Insights
        </a>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col-12 d-flex align-items-center justify-content-between">
      <div class="flex-grow-1 text-center">
        <a
          class="btn btn-dark btn-sm btn-new"
          [routerLink]="['/marketing']"
        >
          Keywords
        </a>
        <a
          class="btn btn-dark btn-sm btn-new"
          [routerLink]="['/marketing/seo/offPageRecommendations']"
        >
          Off-P Recomm
        </a>
        <a
          class="btn btn-dark btn-sm btn-new"
          [routerLink]="['/marketing/seo/offPageProspects']"
        >
          Off-P Prospects
        </a>
        <a
          class="btn btn-dark btn-sm btn-new"
          [routerLink]="['/marketing/seo/offPageBacklinks']"
        >
          Off-P Backlinks
        </a>
      </div>
    </div>
  </div>

  <div class="row mb-3 mt-1">
    <div class="col-md-4">
      <div class="input-group">
        <input
          type="text"
          class="form-control"
          placeholder="Search ..."
          [(ngModel)]="searchText"
          (ngModelChange)="filter()"
          list="suggestionsCourier"
          autocomplete="off"
        />
        <span class="input-group-text bg-transparent"
          ><i class="fas fa-search text-dark"></i
        ></span>
        <datalist id="suggestionsCourier">
          <option
            *ngFor="let suggestion of searchSuggestions"
            [value]="suggestion"
          ></option>
        </datalist>
      </div>
    </div>
  </div>

  <!-- Table -->
  <div class="card shadow-sm">
    <div class="card-body p-0">
      <div class="table-responsive">
        <table class="table table-hover align-middle mb-0">
          <thead class="bg-light">
            <tr>
              <th class="ps-3">Source URL</th>
              <th>Target URL</th>
              <th>Anchor Text</th>
              <th class="text-center">Score</th>
              <th class="text-center">Status</th>
              <th>Inserted At</th>
              <th class="pe-3">Created At</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of filteredData">
              <td class="ps-3">
                <div
                  class="text-truncate"
                  style="max-width: 250px"
                  [title]="item.sourceUrl"
                >
                  {{ item.sourceUrl }}
                </div>
              </td>
              <td>
                <div
                  class="text-truncate"
                  style="max-width: 250px"
                  [title]="item.targetUrl"
                >
                  {{ item.targetUrl }}
                </div>
              </td>
              <td>
                <span class="badge bg-secondary text-white fw-normal">{{
                  item.anchorText
                }}</span>
              </td>
              <td class="text-center">
                <span
                  [ngClass]="
                    item.score >= 30 ? 'text-success fw-bold' : 'text-muted'
                  "
                >
                  {{ item.score }}
                </span>
              </td>
              <td class="text-center">
                <span
                  class="badge"
                  [ngClass]="{
                    'bg-warning text-dark': item.status === 'suggested',
                    'bg-success': item.status === 'inserted',
                    'bg-info': item.status === 'active',
                    'bg-danger': item.status === 'rejected',
                  }"
                >
                  {{ item.status | titlecase }}
                </span>
              </td>
              <td>{{ item.insertedAt | date: "short" || "-" }}</td>
              <td class="pe-3">{{ item.createdAt | date: "short" }}</td>
            </tr>
            <tr *ngIf="filteredData.length === 0">
              <td colspan="7" class="text-center py-5 text-muted">
                <i class="fas fa-info-circle me-2"></i> No records found.
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>
